import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TooltipPanelGroupFeatureComponent} from './tooltip-panel-group-feature.component';

@NgModule({
  declarations: [TooltipPanelGroupFeatureComponent],
  imports: [CommonModule],
  exports: [TooltipPanelGroupFeatureComponent],
})
export class TooltipPanelGroupFeatureModule {}
